import PropTypes from 'prop-types';
import React from 'react';

import { Icon as OrcIcon } from '@ontruck/orc';
import { ReactComponent as Extensible } from 'assets/icons/tenant/vehicle-type-ext.svg';
import { ReactComponent as Short } from 'assets/icons/tenant/vehicle-type-short.svg';
import { ReactComponent as Normal } from 'assets/icons/tenant/vehicle-type-norm.svg';

const vanImage = (props) => <OrcIcon glyph="van" {...props} />;
const boxVanImage = (props) => <OrcIcon glyph="box-van" {...props} />;
const rigidTruckImage = (props) => <OrcIcon glyph="rigid" {...props} />;
const semiTrailerImage = (props) => <OrcIcon glyph="semi-trailer" {...props} />;
const fullTrailerImage = (props) => <OrcIcon glyph="semi-trailer" {...props} />;
const tractorImage = (props) => <OrcIcon glyph="tractor" {...props} />;
const trailerImage = (props) => <OrcIcon glyph="trailer" {...props} />;
const extensiblePltImage = (props) => <Extensible {...props} />;
const twentyPltImage = (props) => <Short {...props} />;
const fourtyPltImage = (props) => <Normal {...props} />;

export const VEHICLE_IMAGES = {
  van: vanImage,
  box_van: boxVanImage,
  rigid_truck: rigidTruckImage,
  semi_trailer: semiTrailerImage,
  full_trailer: fullTrailerImage,
  tractor_unit: tractorImage,
  trailer: trailerImage,
  extensible: extensiblePltImage,
  short_platform: twentyPltImage,
  normal_platform: fourtyPltImage,
};

const getPlatformImage = (platform) => {
  if (platform.is_extensible) return VEHICLE_IMAGES.extensible;
  if (platform.is_short_platform) return VEHICLE_IMAGES.short_platform;
  return VEHICLE_IMAGES.normal_platform;
};

const VehicleImage = ({ type, platform, className, size = '3rem', color = 'grey500' }) => {
  if (!type || typeof type !== 'string') {
    return null;
  }

  let Component;
  Component = platform?.is_platform
    ? getPlatformImage(platform)
    : VEHICLE_IMAGES[type.toLowerCase()];

  return Component ? (
    <span title={type} className={className}>
      <Component className={className} size={size} color={color} />
    </span>
  ) : null;
};

VehicleImage.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
};

export default VehicleImage;
